import { Component, OnInit } from '@angular/core';
import {UserService} from '../user.service';
import {Router} from '@angular/router';

@Component({
  selector: 'page-main-header',
  templateUrl: './page-main-header.component.html'
})
export class PageMainHeaderComponent implements OnInit {

      constructor(
    private userService: UserService,
    private router: Router,
  ) {}

	ngOnInit() {
	}

    logout() {
        this.userService.fullname = '';
        this.userService.user = null;
        this.router.navigate(['/']);
    }

}


// WEBPACK FOOTER //
// ./src/app/page-main-header/page-main-header.component.ts